import React, { useEffect, useState } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { getSupportView, stopSupportView, READ_ONLY_EVENT } from "../../services/supportView";

const EyeIcon = IoEyeOutline as any;

// App-wide: the "viewing as support" bar while Telcofy support has a customer
// open (#557), and a short notice whenever the backend refuses a change because
// the session is read-only (support view, or a viewer), instead of whatever
// generic error the page would show.
const ReadOnlyNotices: React.FC = () => {
  const view = getSupportView();
  const [notice, setNotice] = useState<string | null>(null);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const onRefused = (e: Event) => {
      const code = (e as CustomEvent).detail;
      setNotice(
        code === "support_view_read_only"
          ? "Read-only: nothing can be changed while viewing as support."
          : "Only your organisation's editors can change this."
      );
      clearTimeout(timer);
      timer = setTimeout(() => setNotice(null), 5000);
    };
    window.addEventListener(READ_ONLY_EVENT, onRefused);
    return () => {
      window.removeEventListener(READ_ONLY_EVENT, onRefused);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="print:hidden pointer-events-none fixed inset-x-0 bottom-4 z-[55] flex flex-col items-center gap-2 px-4">
      {notice && (
        <div role="status" className="pointer-events-auto rounded-xl bg-ink px-4 py-2 text-sm text-surface shadow-card">
          {notice}
        </div>
      )}
      {view && (
        <div className="pointer-events-auto flex items-center gap-3 rounded-full border border-warn-line bg-warn-soft py-1.5 pl-3 pr-1.5 text-sm text-warn-ink shadow-card">
          <EyeIcon className="h-4 w-4 flex-shrink-0" />
          <span>
            Viewing <b>{view.name}</b> as Telcofy support · read-only
          </span>
          <button
            onClick={stopSupportView}
            className="rounded-full bg-warn-ink px-3 py-1 text-xs font-semibold text-warn-soft hover:opacity-90"
          >
            Exit
          </button>
        </div>
      )}
    </div>
  );
};

export default ReadOnlyNotices;
